module.exports = __webpack_public_path__ + "img/refresh_outlined_white.59e4a8fb.svg";